import React from 'react';
import { Button } from '@forma/forma-ui-kit';

import styles from './error-boundary.module.css';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error, errorInfo) {
    // Здесь можно логировать ошибку в Sentry, LogRocket и т.п.
    console.error('Client error caught:', error, errorInfo);
  }

  componentDidUpdate(_, prevState) {
    if (this.state.hasError && !prevState.hasError) {
      // Router.push(`/error-client?msg=${this.state.error}`);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.root}>
          <img src="/images/error-robot-2.svg" className={styles.image} alt="Ошибка" />
          <div className={styles.description}>
            <div>
              Произошла ошибка! Используйте это описание при обращении в техническую поддержку
            </div>
            <pre className={styles.code}>{this.state.error}</pre>
          </div>
          <div className={styles.description}>
            <Button size="medium" shadow={true} onClick={() => window.location.reload()}>
              Обновить страницу
            </Button>
          </div>
        </div>

      ); // ничего не рендерим, ждем редиректа
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
